import { useFavorites } from "@/hooks/useFavorites";

interface Props {
  movieId: string | number;
  variant?: "icon" | "button";
  className?: string;
}

export default function FavoriteButton({ movieId, variant = "icon", className = "" }: Props) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const active = isFavorite(movieId);

  if (variant === "button") {
    return (
      <button
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          toggleFavorite(movieId);
        }}
        className={`inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
          active
            ? "bg-primary-500 text-background-50 hover:bg-primary-600"
            : "bg-background-100 text-foreground-800 border border-background-300/70 hover:border-primary-400 hover:text-primary-600"
        } ${className}`}
      >
        <i className={`${active ? "ri-heart-fill" : "ri-heart-line"} text-base`}></i>
        {active ? "已收藏" : "收藏"}
      </button>
    );
  }

  return (
    <button
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleFavorite(movieId);
      }}
      aria-label={active ? "取消收藏" : "收藏"}
      className={`w-9 h-9 rounded-full flex items-center justify-center backdrop-blur-sm transition-colors cursor-pointer ${
        active
          ? "bg-primary-500 text-background-50"
          : "bg-foreground-950/45 text-background-50 hover:bg-primary-500"
      } ${className}`}
    >
      <i className={`${active ? "ri-heart-fill" : "ri-heart-line"} text-base`}></i>
    </button>
  );
}